import { TabPane as _TabPane, TabPaneProps as _TabPaneProps } from "reactstrap";

    export const TabPane = _TabPane;
    export type TabPaneProps = _TabPaneProps;
    